export default function SvgIcon() {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          display: 'block'
        },
        fontSizeSmall: {
          width: 20,
          height: 20,
          fontSize: 'inherit'
        },
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: 'inherit'
        }
      }
    }
  };
}
